/**
 * REQUEST MODULE
 *
 * A wrapper to handle AJAX requests
 *
 * Available methods:
 * 	.get( action, paramsObject, successCallback, failCallback )
 * 	.post( action, dataObject, successCallback, failCallback )
 * 	.ajax( jQueryAJAXoptions )
 */

VP = window.VP || {};

(function( $ ) {
	VP.request = {
		/**
		 * Performs a GET request
		 * @param  {string} action
		 * @param  {Object} params          url params to be url-encoded
		 * @param  {function} successCallback (optional)
		 * @param  {function} failCallback    (optional)
		 * @param  {function} alwaysCallback    (optional)
		 * @return {object}                 jQuery ajax object (which can be aborted)
		 */
		get: function ( action, params, successCallback, failCallback, alwaysCallback ) {
			if ( ! action )  { return; }

			// Ensure params as object
			params = typeof params === 'object' ? params : {};

			// Serialize parameters
			params = $.param(params);

			// Send request
			return $.get( '/ajax/' + action + '?' + params, successCallback ).fail( failCallback ).always( alwaysCallback );
		},

		/**
		 * Performs a POST request
		 * @param  {string} action
		 * @param  {Object} data
		 * @param  {function} successCallback (optional)
		 * @param  {function} failCallback    (optional)
		 * @return {object}                 jQuery ajax object (which can be aborted)
		 */
		post: function ( action, data, successCallback, failCallback ) {

			if ( ! action )  { return; }
			// Ensure data as object
			data = typeof data === 'object' ? data : {};

			// Send request
			return $.ajax({
				method: 'POST',
				url: '/index.php?ajax=' + action,
				data: data,
				success: successCallback,
				error: failCallback,
			});
		},

		/**
		 * Performs a raw jQuery.ajax request
		 * See: http://api.jquery.com/jquery.ajax/
		 * @param  {object} options
		 * @return {object} jquery ajax object
		 */
		ajax: function ( options ) {
			return $.ajax( options );
		}
	};
})(jQuery);
